/**
 * Lesson MCQ Content Type
 * A split-view content type with lesson content (Page) and MCQ questions
 */

// Package version
import pkgJson from '../package.json';
export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

// Schema and types
export {
    lessonMCQSchema,
    defaultLessonMCQConfig,
    defaultLessonMCQData,
    defaultLessonMCQI18n,
    getSplitGridCols,
    type LessonMCQContent,
    type LessonMCQData,
    type LessonMCQConfig,
    type LessonMCQLayoutConfig,
    type LessonMCQScoringConfig,
    type SplitRatio,
} from './schema';

// Components
export { LessonMCQEdit, type LessonMCQEditProps } from './LessonMCQEdit';
export { LessonMCQPlayer, type LessonMCQPlayerProps } from './LessonMCQPlayer';

// Default export
export { lessonMCQSchema as default } from './schema';

export { lessonMCQValidator } from './validator';

export { countLessonMCQQuestions, lessonMCQQuestionCounter } from './questionCount';
